import { ReactElement } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'usehooks-ts';

type Props = Pick<ButtonProps, 'onClick'> & {
  label?: string;
  path?: string;
  navToPrevious?: boolean;
  emptyPlaceholder?: ReactElement;
};

export const PageLayoutHeaderGoBackBtn = ({
  path,
  label,
  navToPrevious,
  onClick,
  emptyPlaceholder = <span />,
}: Props) => {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const isMobileView = useMediaQuery('(max-width: 768px)');
  const pathFromState = navToPrevious && state?.from;
  const backLabel = pathFromState ? 'Go back' : label;
  const handleNavigate = () =>
    navigate(pathFromState || path, { state: { from: pathname } });

  if (!pathFromState && !path && !onClick) {
    return emptyPlaceholder;
  }
  return (
    <Button
      type="text"
      icon={<ArrowLeftOutlined style={{ fontSize: isMobileView ? 14 : 12 }} />}
      onClick={onClick || handleNavigate}
      style={{
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        minWidth: isMobileView ? 18 : 132,
      }}
    >
      {!isMobileView && backLabel}
    </Button>
  );
};
